.multiInput {
  display: inline-block;
  width: 40px;
  padding: 0.375rem 0.625rem;
  &__error {
    border-color: red;
  }
}
